import { render } from "./OrderCustomsPushPage.vue?vue&type=template&id=2c60e150&scoped=true"
import script from "./OrderCustomsPushPage.vue?vue&type=script&lang=js"
export * from "./OrderCustomsPushPage.vue?vue&type=script&lang=js"

import "./OrderCustomsPushPage.vue?vue&type=style&index=0&id=2c60e150&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2c60e150"

export default script